import { render, staticRenderFns } from "./LearningItemManager.vue?vue&type=template&id=1f13f868&scoped=true&"
import script from "./LearningItemManager.vue?vue&type=script&lang=js&"
export * from "./LearningItemManager.vue?vue&type=script&lang=js&"
import style0 from "./LearningItemManager.vue?vue&type=style&index=0&id=1f13f868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f13f868",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VRow,VSpacer,VSwitch})
